export default __webpack_public_path__ + "static/beatbugs-5-c42737e48a2b88f02a3cfe8587ef3e5a.webp";